import webBiLogger from '@wix/web-bi-logger';
import { appDashboardHomePageClickSrc96Evid49, devCenterInstallerSdkNewConsentModalCtaClickSrc96Evid28, devCenterInstallerSdkNewConsentModalLoadedSrc96Evid27, devCenterInstallerSdkNewErrorModalLoadedSrc96Evid22, devCenterInstallerSdkNewInstallCallSentSrc96Evid23, devCenterInstallerSdkNewInstallFailedSrc96Evid25, devCenterInstallerSdkNewInstallInitiatedSrc96Evid26, devCenterInstallerSdkNewInstallSuccessSrc96Evid24, devCenterInstallerSdkModalUnmountedSrc96Evid217, devCenterInstallerSdkOAuthAppUrlEndSrc96Evid207, devCenterInstallerSdkOAuthAppUrlStartSrc96Evid206, devCenterInstallerSdkOAuthRedirectUrlEndSrc96Evid209, devCenterInstallerSdkOAuthRedirectUrlStartSrc96Evid208, devCenterInstallerSdkPostInstallationNavigationSrc96Evid210 } from '@wix/bi-logger-dev-center-data/v2';
import isUndefined from 'lodash/isUndefined';
let logger;
export const initBiLogger = _ref => {
  let {
    appId,
    tenantId,
    platform,
    version,
    tenantType,
    silentInstall,
    avoidPostInstallation,
    correlationId,
    installationId,
    isMarketingConsent,
    pageId
  } = _ref;
  logger = webBiLogger.factory().logger();
  logger.updateDefaults({
    app_id: appId,
    installation_id: installationId,
    install_origin: window.location.href,
    route: window.location.pathname,
    correlation_id: correlationId,
    is_silent_install: silentInstall,
    avoid_post_installation: avoidPostInstallation,
    platform,
    version: isUndefined(version) ? 'undefined' : version,
    external_content_mode: isMarketingConsent ? 'marketing_consent' : null,
    is_advance_oauth: null,
    is_external_dashboard: null,
    ...(tenantType === 'SITE' && {
      msid: tenantId
    }),
    page_id: pageId ? pageId : null
  });
};
export const updateBiLoggerDefaults = _ref2 => {
  let {
    metaSiteId,
    isAdvanceOauth,
    isExternalDashboard
  } = _ref2;
  logger.updateDefaults({
    ...(!isUndefined(metaSiteId) ? {
      msid: metaSiteId
    } : {}),
    ...(!isUndefined(isAdvanceOauth) ? {
      is_advance_oauth: isAdvanceOauth
    } : {}),
    ...(!isUndefined(isExternalDashboard) ? {
      is_external_dashboard: isExternalDashboard
    } : {})
  });
};
export const reportInstallerInitiated = () => {
  var _logger;
  (_logger = logger) == null || _logger.report(devCenterInstallerSdkNewInstallInitiatedSrc96Evid26({}));
};
export const reportInstallSuccess = _ref3 => {
  var _logger2;
  let {
    requestId,
    instanceId
  } = _ref3;
  return (_logger2 = logger) == null ? void 0 : _logger2.report(devCenterInstallerSdkNewInstallSuccessSrc96Evid24({
    request_id: requestId,
    instance_id: instanceId
  }));
};
export const reportInstallRequestFired = () => {
  var _logger3;
  return (_logger3 = logger) == null ? void 0 : _logger3.report(devCenterInstallerSdkNewInstallCallSentSrc96Evid23({}));
};
export const reportInstallFailed = requestId => {
  var _logger4;
  return (_logger4 = logger) == null ? void 0 : _logger4.report(devCenterInstallerSdkNewInstallFailedSrc96Evid25({
    request_id: requestId
  }));
};
export const reportErrorModalLoaded = (errorReason, errorContentType) => {
  var _logger5;
  return (_logger5 = logger) == null ? void 0 : _logger5.report(devCenterInstallerSdkNewErrorModalLoadedSrc96Evid22({
    error_content_type: errorContentType,
    error_reason: errorReason
  }));
};
export const reportErrorModalCTAClick = (ctaName, errorReason) => {
  var _logger6;
  return (_logger6 = logger) == null ? void 0 : _logger6.report(appDashboardHomePageClickSrc96Evid49({
    cta_name: ctaName,
    error_reason: errorReason,
    error_content_type: errorReason
  }));
};
export const reportModalShown = modalType => {
  var _logger7;
  return (_logger7 = logger) == null ? void 0 : _logger7.report(devCenterInstallerSdkNewConsentModalLoadedSrc96Evid27({
    modal_type: modalType
  }));
};
export const reportModalUnmounted = (modalType, isBulkInstallApiTriggered) => {
  var _logger8;
  return (_logger8 = logger) == null ? void 0 : _logger8.report(devCenterInstallerSdkModalUnmountedSrc96Evid217({
    modal_type: modalType,
    was_bulk_install_invoked: isBulkInstallApiTriggered
  }));
};
export const reportModalCtaClick = _ref4 => {
  var _logger9;
  let {
    ctaName,
    modalType
  } = _ref4;
  return (_logger9 = logger) == null ? void 0 : _logger9.report(devCenterInstallerSdkNewConsentModalCtaClickSrc96Evid28({
    modal_type: modalType,
    cta_name: ctaName
  }));
};
export const reportAppUrlStart = _ref5 => {
  var _logger10;
  let {
    url
  } = _ref5;
  return (_logger10 = logger) == null ? void 0 : _logger10.report(devCenterInstallerSdkOAuthAppUrlStartSrc96Evid206({
    url
  }));
};
export const reportAppUrlEnd = _ref6 => {
  var _logger11;
  let {
    url
  } = _ref6;
  return (_logger11 = logger) == null ? void 0 : _logger11.report(devCenterInstallerSdkOAuthAppUrlEndSrc96Evid207({
    url
  }));
};
export const reportRedirectUrlStart = _ref7 => {
  var _logger12;
  let {
    url
  } = _ref7;
  return (_logger12 = logger) == null ? void 0 : _logger12.report(devCenterInstallerSdkOAuthRedirectUrlStartSrc96Evid208({
    url
  }));
};
export const reportRedirectUrlEnd = _ref8 => {
  var _logger13;
  let {
    url
  } = _ref8;
  return (_logger13 = logger) == null ? void 0 : _logger13.report(devCenterInstallerSdkOAuthRedirectUrlEndSrc96Evid209({
    url
  }));
};
export const reportPostInstallation = _ref9 => {
  var _logger14;
  let {
    destination
  } = _ref9;
  return (_logger14 = logger) == null ? void 0 : _logger14.report(devCenterInstallerSdkPostInstallationNavigationSrc96Evid210({
    destination
  }));
};
//# sourceMappingURL=bi.js.map